import Vue from 'vue';
import * as _ from 'lodash';

export default Vue.filter('toCapitalize', value => _.startCase(_.replace(_.toLower(value), '_', ' ')));


// WEBPACK FOOTER //
// ./src/filters/toCapitalize.js